export const tabs = {
    ANALYTICS: 'analytics',
    CASE: 'case',
    DEATH: 'death',
};
